import { BookkeeperCompanyIncidenceOptionFragment } from 'generated/resources/graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import asyncAction from 'modules/core/lib/asyncAction'

import incidenceOptions from 'modules/bookkeepers/store/collections/incidenceOptions'

export interface IncidenceOptionsType {
  id: string
  name: string
  disabled: boolean
  identifier: string
  getTranslatedTitle: () => string
  getTranslatedDescription: () => string
}

export const isIncidenceActiveForCompany = (
  companyIncidenceSettings: BookkeeperCompanyIncidenceOptionFragment[],
  type: IncidenceOptionsType
) => {
  const companySetting = companyIncidenceSettings.find((model) => {
    return model.incidenceName === type.id || model.leaveTypeId === String(type.id)
  })

  return companySetting ? companySetting.trackIncidence : false
}

export const incidenceNeedsCompanyValidation = (
  companyIncidenceSettings: BookkeeperCompanyIncidenceOptionFragment[],
  type: IncidenceOptionsType
) => {
  const companySetting = companyIncidenceSettings.find((model) => {
    return model.incidenceName === type.id || model.leaveTypeId === String(type.id)
  })

  return companySetting ? companySetting.needsValidation : true
}

export const trackIncidenceOptionSettings = (
  companyName: string | undefined,
  incidenceName: string,
  isValidation: boolean,
  application: string,
  option: BookkeeperCompanyIncidenceOptionFragment | undefined
) => {
  let status = false
  let event = trackingEvents.bookkeeper.clients.changeClientNotification
  if (isValidation) {
    status = option ? !option.needsValidation : false
    event = trackingEvents.bookkeeper.clients.changeIncidentValidation
  } else if (option) {
    status = option.trackIncidence
  }
  track(event, {
    application: application,
    status: status,
    value_name: incidenceName,
    company_name: companyName,
  })
}

export const createIncidenceOptionSettings = (
  incidenceName: string,
  companyId: string,
  leaveTypeId: string | undefined | null,
  isBookkeeperView = true,
  isValidation = false
) => {
  // This is a bit confussing. `isValidation` is used to know if we're switching
  // the toggle of track incidence of the one from validation. As, the default for
  // track_incidence is false, it makes sense that, if it's created for the first time
  // it's set to true. It has a lot of dependencies, so if someone is brave enough,
  // feel free to change it.
  return asyncAction(() =>
    incidenceOptions.create({
      bookkeeper_view: isBookkeeperView,
      company_id: companyId,
      incidence_name: incidenceName,
      track_incidence: !isValidation,
      leave_type_id: leaveTypeId,
      needs_validation: !isValidation,
    })
  )
}
